import { getEnv } from '@/shared/configs';
import { v4 as uuidv4 } from 'uuid';
import { getCookie, setCookie } from '@/shared/utils';

export enum SplitFeatureFlag {
  SMB_PHONE_NUMBER_MANDATORY_AB_TEST = 'smb_phone_number_mandatory_ab_test',
  SMB_PHONE_NUMBER_KILL_SWITCH = 'MONARCH-473_smb_phone_number_kill_switch',
  MONARCH_303_NEW_ENROLLMENT_CONFIRMATION_PAGE_AB_TEST = 'monarch-303-new-enrollment-confirmation-page-ab-test',
  MONARCH_446_SWAP_BUILDINGS_TO_PROPERTY_API = 'MONARCH-446_swap_buildings_to_property_api',
  MONARCH_474_NEW_BROKER_SIGNUP_FORM = 'MONARCH-474_new_broker_signup_form',
  MONARCH_474_USE_MODERN_BROKER_SIGNUP_API = 'MONARCH-474_use_modern_broker_signup_api',
  MONARCH_531_TRANSUNION_SMB_PHONE_NUMBER_MANDATORY_AB_TEST = 'MONARCH-531_TRANSUNION_SMB_PHONE_NUMBER_MANDATORY_AB_TEST',
  REN_10732_INFINITE_WATCH_SCRIPT = 'REN-10732_infinite_watch_script', // on since 11/2025
  OTTERS_4648_USE_GO_LLP_BE_REGISTER_ENDPOINT = 'OTTERS-4648_use_go_llp_be_register_endpoint',
  LLX_4871_USE_GO_LLP_BE_GET_ME_ENDPOINT = 'LLX-4871_use_go_llp_be_get_me_endpoint',
  LLX_4964_EXPIRED_BONDS_TOGGLE_APP_TRACKER = 'LLX-4964-expired_bonds_toggle_app_tracker',
  LLX_4728_APP_TRACKER_INVITE_AMENDMENTS = 'LLX-4728_app_tracker_invite_amendments',
  CLAIMS_241_RESTRICT_LEDGER = 'CLAIMS-241_restrict_ledger',
  CLAIMS_351_BOND_V2_SEARCH = 'CLAIMS-351_bond_v2_search',
  ZGRI_3733_OCCUPANCY_FEED = 'zgri-3733_occupancy_feed',
}

export const COOKIE_KEY = 'split_anonymous_id';

export const getSplitAnonymousId = (): string => {
  let id = getCookie(COOKIE_KEY);
  if (!id) {
    id = uuidv4();
    setCookie(COOKIE_KEY, id, 365);
  }
  return id;
};

export const splitConfig = {
  core: {
    authorizationKey: getEnv().split_io_api_key || '',
    key: getSplitAnonymousId(),
  },
};
